<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form :model="brows" label-position="right" class="mainfrom from_input">
        <el-form-item label="游览器名">
          <el-input v-model="brows.browscode" :maxlength="20" show-word-limit :disabled="disable"></el-input>
        </el-form-item>

        <el-form-item label="游览器说明">
          <el-input v-model="brows.browsname" :maxlength="40" show-word-limit :disabled="disable"></el-input>
        </el-form-item>

        <el-form-item label="数据源">
          <el-select v-model="brows.browsdsid" :clearable="true">
            <el-option v-for="(item, index) in dsList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'

  export default {
    name: "browsform",
    data () {
      return {
        brows: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        dsList: []
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getDsList()
    },
    watch: {},
    filters: {},
    methods: {
      async init () {
        this.brows = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.dsList = []
      },
      async getDsList () {
        this.dsList = await request({
          url: '/xtgl/ds/getDsList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async save () {
        let model = {
          insertRecords: [],
          updateRecords: [],
          removeRecords: []
        }
        if (this.brows.browsid === 0) {
          this.brows.comid = this.$store.getters.loginUser.usercomid
          this.brows.browsissys = 1
          model.insertRecords = [this.brows]
        } else {
          model.updateRecords = [this.brows]
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length === 0 && model.updateRecords.length === 0 && model.removeRecords.length === 0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/kfgl/brows/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess === 1) {
          this.$message.success('保存成功')
          this.close()
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'browsIndex'})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 840px;
    }
  }
</style>
